import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";

/** کش Emotion با پلاگین RTL تا margin/padding/transform و … برای MUI درست آینه شوند. */
export const emotionCacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});
